import React from 'react';

const PageHeading = ({ headingTxt }) => {
  return (
    <div className={'page-heading-wrapper'}>
      <div className='page-inner'>
        <figure className='page-heading-bg-group'>
          <img
            fetchpriority='high'
            src='/bg_page_heading.png'
            alt=''
            className={'page-heading-bg'}
            decoding={'async'}
          />
        </figure>
        <div className='layout-inner'>
          <h2 className={'page-heading-title'}>{headingTxt}</h2>
        </div>
      </div>
    </div>
  );
};

export default PageHeading;
